import Spanish from "assets/images/header-images/Spanish.svg";
import Chinese from "assets/images/header-images/chinese.svg";
import Portuguese from "assets/images/header-images/portuguese.svg";
import German from "assets/images/header-images/german.svg";
import Russian from "assets/images/header-images/russian.svg";
import Hebrew from "assets/images/header-images/hebrew.svg";
import Detect_icon from "assets/detect_icon.svg";
import Translation_icon from "assets/translation_icon.svg";
import Wordcount from "assets/word_count.svg";
import DataAnonymizationTool from "assets/data-anonymization.svg";
import TopicTool from "assets/topic.svg";
import ContextualIcon from "assets/contextual.svg"
import ConsistencyIcon from "assets/consistency.svg";
import Glossary from "assets/glossary.svg";
import Difficulty from "assets/Translation_Difficulty_Checker.svg";
import PreTranslationIcon from "assets/pre-translation.svg";
import SourceIcon from "assets/sourceicon.svg"
import StyleGuide from "assets/styleguide.svg"
import PostTranslationIcon from "assets/post-translation.svg";
import EditingIcon from "assets/editingIcon.svg";
import Transcription from "assets/transc.svg";
import ImageText from "assets/imagetext.svg";
import Summary_icon from "assets/summary_icon.svg";

export const Services = [
  {
    list: "Translation Services",
    link: "/translation-services",
    byline: "Professional language translation by human translators",
  },
  {
    list: "Website Translation",
    link: "/website-translation.php",
    byline: "Scalable website translation solutions for any platform",
  },
  // {
  //   list: "Document Translation",
  //   link: "/document-translation-services",
  //   byline:
  //     "For more complex translation needs, industry-specific document translation.",
  // },
  // {
  //   list: "Website Translation",
  //   link: "/website-translation.php",
  //   byline: "Full and partial translation or localization of websites.",
  // },
  // { list: "Legal Translation", link: "/legal-translation", byline :"End-to-end translation services for your business for all your globalization needs." },
  // { list: "Medical Translation" , link : "/medical-translation", byline :"End-to-end translation services for your business for all your globalization needs." },
  // { list: "Technical Translation", link: "/technical-translation" },
  // { list: "Marketing Translation" ,  link: "/marketing-translation"},
  // { list: "Financial Translation" , link : "/financial-translation" },
  // { list: "Video Translation" , link : "/video-translation" },
  // { list: "Localization" , link  : "/localization-services"},
  // {
  //   list: "Software Translation",
  //   link: "/software-translation.php",
  //   byline:
  //     "Translation and localization of apps, games and other sector-specific software.",
  // },
  // { list: "Interpreting" , link : "/interpretation-services" },
  // { list: "Translation On-Demand" , link : "/services/real-time-translation" },
];

export const Services2 = [
  {
    list: "Certified Translation",
    link: "/certified-translation.php",
    byline: "",
  },
  {
    list: "Video Translation",
    link: "/video-translation",
    byline: "",
  },
  {
    list: "Localization Services",
    link: "/localization-services.php",
    byline: "",
  },
  {
    list: "Interpreting Services",
    link: "/interpretation-services",
    byline: "",
  },
];

export const Industries = [
  { data: "Legal", link: "/legal-translation.php" },
  { data: "Finance", link: "/financial-translation.php" },
  { data: "Healthcare", link: "/industries/healthcare-translation-services" },
  { data: "Academic", link: "/industries/academic-translation-services" },
  { data: "Ecommerce", link: "/industries/ecommerce-translation-services" },
  {
    data: "Gaming",
    link: "/industries/gaming-translation-services",
  },
  {
    data: "Media",
    link: "/industries/media-translation-services",
  },
  {
    data: "Life Sciences",
    link: "/industries/life-sciences-translation-services",
  },
  {
    data: "Manufacturing",
    link: "/industries/manufacturing-translation-services",
  },
  {
    data: "Fashion & Luxury ",
    link: "/industries/fashion-textile-translation-services",
  },
  {
    data: "Automotive",
    link: "/industries/automotive-translation-services",
  },
  {
    data: "Travel & Tourism",
    link: "/industries/tourism-translation-services",
  },
];
export const HeaderToolsList = [
  {
    text: "AI Translator",
    img_link: EditingIcon,
    href: "/tools/ai-translator",
    key: "pre",
  },
  {
    text: "Audio to Text Converter",
    img_link: Transcription,
    href: "/tools/ai-transcription",
    key: "pre",
  },
  {
    text: "Image to Text Converter",
    img_link: ImageText,
    href: "/tools/image-to-text",
    key: "pre",
  },
  {
    text: "Translation Quality Assessment",
    img_link: Translation_icon,
    href: "/tools/post-translation",
    key: "pre",
  },
  {
    text: "Pre-Translation Toolkit",
    img_link: PreTranslationIcon,
    href: "/tools/pre-translation",
    key: "pre",
  },
  {
    text: "Language Detector",
    img_link: Detect_icon,
    href: "/tools/language-detector",
    key: "post",
  },
    {
    text: "Text Summarizer",
    img_link: Summary_icon,
    href: "/tools/text-summarizer",
    key: "post",
  },
  {
    text: "Translation Difficulty Checker",
    img_link: Difficulty,
    href: "/tools/translation-difficulty-checker",
    key: "post",
  },
  {
    text: "Bilingual Glossary Generator",
    img_link: Glossary,
    href: "/tools/glossary-generator",
    key: "post",
  },
  {
    text: "Data Anonymization",
    img_link: DataAnonymizationTool,
    href: "/tools/data-anonymization",
    key: "post",
  },
 
];
export const ToolsLinks = [
  {
    text: "Pre-Translation Toolkit",
    img_link: PreTranslationIcon,
    href: "/tools/pre-translation",
    key: "pre",
  },
  {
    text: "AI-Powered Translation QA Tool",
    img_link: PostTranslationIcon,
    href: "/tools/post-translation",
    key: "post",
  },
  {
    text: "Bilingual Glossary Generator",
    img_link: Glossary,
    href: "/tools/glossary-generator",
    key: "post",
  },
  {
    text: "Translation Difficulty Checker",
    img_link: Difficulty,
    href: "/tools/translation-difficulty-checker",
    key: "pre",
  },
  {
    text: "Translation Quality Assurance",
    img_link: Translation_icon,
    href: "/tools/translation-quality-assurance",
    key: "post",
  },

  {
    text: "Consistency Checker",
    img_link: ConsistencyIcon,
    href: "/tools/translation-consistency-checker",
    key: "post",
  },

  {
    text: "Topic Detection",
    img_link: TopicTool,
    href: "/tools/topic-detection",
    key: "pre",
  },

  {
    text: "Data Anonymization Tool",
    img_link: DataAnonymizationTool,
    href: "/tools/data-anonymization",
    key: "pre",
  },
  {
    text: "Source Text Checker ",
    img_link: SourceIcon,
    href: "/tools/source-text-checker",
    key: "pre",
  },
  {
    text: "Style Guide Generator",
    img_link: StyleGuide,
    href: "/tools/style-guide-generator",
    key: "pre",
  },

  {
    text: "Key Terms Glossary",
    img_link: ContextualIcon,
    href: "/tools/contextual-glossary-generator",
    key: "pre",
  },

  {
    text: "Translation Guideline Adherence Checker",
    img_link: Wordcount,
    href: "/tools/guideline-adherence-checker",
    key: "post",
  },
  {
    text: "Language Detector",
    img_link: Detect_icon,
    href: "/tools/language-detector",
    key: "post",
  },
  // {
  //   text: "Online Summarization",
  //   img_link: Summary_icon,
  //   href: "/tools/text-summarizer",
  //   key: "post",
  // },

  // {
  //   text: "Word Count Ratio",
  //   img_link: Wordcount,
  //   href: "/tools/word-count-ratio",
  //   key: "post",
  // },
];
export const Languages = [
  {
    list: "Arabic ",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/arabic.png",
    link: "/languages/arabic",
  },
  {
    list: "Korean",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/korean.png",
    link: "/languages/korean",
  },
  {
    list: "Chinese ",
    img_link: Chinese,
    link: "/languages/chinese",
  },
  {
    list: "Polish",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/polish.png",
    link: "/languages/polish",
  },

  {
    list: "Dutch",
    img_link: "https://tomedes.gumlet.io/assets/images/header-images/dutch.png",
    link: "/languages/dutch",
  },
  {
    list: "Portuguese",
    img_link: Portuguese,
    link: "/languages/portuguese",
  },
  {
    list: "French ",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/french.png",
    link: "/languages/french",
  },
  {
    list: "Russian",
    img_link: Russian,
    link: "/languages/russian",
  },
  {
    list: "German",
    img_link: German,
    link: "/languages/german",
  },
  {
    list: "Turkish",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/turkish.png",
    link: "/languages/turkish",
  },
  {
    list: "Hebrew",
    img_link: Hebrew,
    link: "/languages/hebrew",
  },
  {
    list: "Vietnamese",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/veitnamese.png",
    link: "/languages/vietnamese",
  },
  {
    list: "Italian",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/italian.png",
    link: "/languages/italian",
  },
  {
    list: "Spanish ",
    img_link: Spanish,
    link: "/english-to-spanish-translation-service.php",
  },
  {
    list: "Japanese",
    img_link:
      "https://tomedes.gumlet.io/assets/images/header-images/japanese.png",
    link: "/languages/japanese",
  },
  {
    list: "More Languages",
    underline: "underline",
    img_link: "",
    link: "/languages",
  },
];
export const AboutData = [
  { link: "/about-tomedes", list: "About Us" },
  { link: "/about/leadership", list: "Leadership" },
  { link: "/our-customers", list: "Our Customers" },
  { link: "/careers", list: "Careers" },
  { link: "/reviews.php", list: "Reviews" },
  { link: "/quality-policy", list: "Quality Policy" },
  { link: "/iso-certifications", list: "ISO Certifications" },
  // { link: "/about/1-year-guarantee", list: "1-Year Guarantee" },
  // { link: "/about/fast-delivery", list: "Fast Delivery" },
  // { link: "/about/available-24/7", list: "Available 24/7" },
  // { link: "/about/customer-centricity", list: "Customer Centricity" },
  { link: "/recent-translations.php", list: "Case Studies" },
  { link: "/translators", list: "Our Translators" },
  { link: "/translator-hub.php", list: "Blog" },
  { link: "/business-center.php", list: "Business Center" },
  // { link: "/tools", list: "Tools" },
];

export const TranslationData = [
  { link: "/translation-services", list: "Document Translation" },
  { link: "/localization-services", list: "Localization Services" },
  // { link: "/translation-services", list: "Translation Services" },
  { link: "/website-translation.php", list: "Website Translation" },
  // {
  //   link: "/translation-services/legal-translation",
  //   list: "Legal Translation",
  // },
  { link: "/video-translation", list: "Video Translation" },
  { link: "/certified-translation", list: "Certified Translation" },
];

export const LocalizationData = [
  { link: "/localization-services/software", list: "Software Localization" },
  { link: "/localization-services/game", list: "Game Localization" },
  { link: "/localization-services/app", list: "App Localization" },
  { link: "/localization-services/website", list: "Website Localization" },
];

export const InterpretationData = [
  // {
  //   link: "/interpretation-services/medical-interpreting",
  //   list: "Medical Interpreting",
  // },
  {
    link: "/interpretation-services/legal-interpreting",
    list: "Legal Interpreting",
  },
  {
    link: "/interpretation-services/on-site-in-person",
    list: "On-site Interpreting",
  },
  {
    link: "/interpretation-services/simultaneous-interpreting",
    list: "Simultaneous Interpreting",
  },
  { link: "/interpretation-services/zoom", list: "Zoom Interpreting" },
  {
    link: "/interpretation-services/conference-interpreting",
    list: "Conference Interpreting",
  },
  // {
  //   link: "/interpretation-services/consecutive-interpreting",
  //   list: "Consecutive Interpreting",
  // },
];
export const IndustryExpertiseData = [
  {
    link: "/translation-services/legal-translation",
    list: "Legal",
  },
  {
    link: "/translation-services/academic-translation ",
    list: "Education",
  },

  {
    link: "/industries/nonprofit-translation-services",
    list: "NGO",
  },
  {
    link: "/industries/tourism-translation-services",
    list: "Travel",
  },
  {
    link: "/localization-services/game",
    list: "Gaming",
  },
];
